import * as types from './unitActionTypes';

const initialState = {
  unitData: null,
  unitList: [],
  createUnitData: null,
  createUnitError: null,
  updateUnitData: null,
  updateUnitError: null,
  deleteUnitData: null,
  deleteUnitError: null,
};

export const unitReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_UNIT_DATA:
      return {
        ...state,
        unitData: action.payload || null,
        unitList: action.payload?.UnitList || [],
      };
    case types.GET_UNIT_ERROR:
      return {
        ...state,
        unitData: null,
        unitList: [],
      };
    case types.CREATE_UNIT_DATA:
      return {
        ...state,
        createUnitData: action.payload,
        createUnitError: null,
      };
    case types.CREATE_UNIT_ERROR:
      return {
        ...state,
        createUnitData: null,
        createUnitError: action.payload,
      };
    case types.UPDATE_UNIT_DATA:
      return {
        ...state,
        updateUnitData: action.payload,
        updateUnitError: null,
      };
    case types.UPDATE_UNIT_ERROR:
      return {
        ...state,
        updateUnitData: null,
        updateUnitError: action.payload,
      };
    case types.DELETE_UNIT_DATA:
      return {
        ...state,
        deleteUnitData: action.payload,
        deleteUnitError: null,
      };
    case types.DELETE_UNIT_ERROR:
      return {
        ...state,
        deleteUnitData: null,
        deleteUnitError: action.payload,
      };
    default:
      return state;
  }
};
